'use strict';

var FilterClassGridPostDepartureFilterFactory = function FilterClassGridPostDepartureFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightDateRangeFilterFactory', 'FlightLevelFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FilterClassGridFilter() {
    DemandFilter.call(this, 'class', 'class-flight-analysis-post-departure');
    this.registerFilters(injectedFilters);
  }
  FilterClassGridFilter.constructor = FilterClassGridFilter;
  FilterClassGridFilter.prototype = Object.create(DemandFilter.prototype);
  return FilterClassGridFilter;
};
FilterClassGridPostDepartureFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FilterClassGridPostDepartureFilterFactory;